import { API_BASE_URL, API_KEY } from '@/utils/apiConfig';

const SUPABASE_FUNCTION_URL = `${API_BASE_URL}/manage-device-mfa`;

// Helper function to get auth headers
const getAuthHeaders = async () => {
  try {
    const { supabase } = await import('@/integrations/supabase/client');
    const { data: { session } } = await supabase.auth.getSession();
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${session?.access_token || ''}`,
      'apikey': API_KEY
    };
  } catch (e) {
    // Propagate error so callers can handle according to tests
    throw e;
  }
};

export const setDeviceMfaCookie = async (email: string): Promise<boolean> => {
  try {
    const headers = await getAuthHeaders();
        
    const response = await fetch(SUPABASE_FUNCTION_URL, {
      method: 'POST',
      headers,
      credentials: 'include',
      body: JSON.stringify({ action: 'set', email })
    });

    if (!response.ok) {
      console.error('[deviceMfaCookie] Error setting device MFA cookie:', response.statusText);
      return false;
    }

    const data = await response.json();
    
    if (data.error) {
      console.error('[deviceMfaCookie] Error setting device MFA cookie:', data.error);
      return false;
    }

    return true;
  } catch (error) {
    console.error('[deviceMfaCookie] Error setting device MFA cookie:', error);
    return false;
  }
};

export const verifyDeviceMfaCookie = async (): Promise<{ valid: boolean; email?: string }> => {
  try {    
    const headers = await getAuthHeaders();

    const response = await fetch(SUPABASE_FUNCTION_URL, {
      method: 'POST',
      headers,
      credentials: 'include', // This ensures cookies are sent with the request
      body: JSON.stringify({ action: 'verify' }) // No cookieValue needed - server reads from headers
    });

    if (!response.ok) {
      console.error('[deviceMfaCookie] Error verifying device MFA cookie:', response.statusText);
      return { valid: false };
    }

    const data = await response.json();

    if (data.error) {
      console.error('[deviceMfaCookie] Error verifying device MFA cookie:', data.error);
      return { valid: false };
    }

    return { valid: data.valid, email: data.email };
  } catch (error) {
    console.error('[deviceMfaCookie] Error verifying device MFA cookie:', error);
    return { valid: false };
  }
};

export const clearDeviceMfaCookie = async (): Promise<boolean> => {
  try {
    const headers = await getAuthHeaders();

    const response = await fetch(SUPABASE_FUNCTION_URL, {
      method: 'POST',
      headers,
      credentials: 'include',
      body: JSON.stringify({ action: 'clear' })
    });

    if (!response.ok) {
      console.error('[deviceMfaCookie] Error clearing device MFA cookie:', response.statusText);
      return false;
    }

    const data = await response.json();

    if (data.error) {
      console.error('[deviceMfaCookie] Error clearing device MFA cookie:', data.error);
      return false;
    }

    return true;
  } catch (error) {
    console.error('[deviceMfaCookie] Error clearing device MFA cookie:', error);
    return false;
  }
};
